import { supabase } from '../lib/supabase';

export const subscriptionService = {
  async createCheckoutSession(planCode) {
    try {
      const { data: session } = await supabase.auth.getSession();
      const user = session?.user;
      
      if (!user) {
        throw new Error('User not authenticated');
      }

      // Get user profile to find org_id
      const { data: userProfile } = await supabase
        .from('users')
        .select('org_id')
        .eq('id', user.id)
        .single();

      const { data, error } = await supabase.functions.invoke('create-checkout-session', {
        body: {
          planCode,
          userId: user.id,
          userEmail: user.email,
          orgId: userProfile?.org_id
        }
      });

      if (error) throw error;

      return data;
    } catch (error) {
      console.error('Checkout session creation failed:', error);
      throw error;
    }
  },

  async getSubscriptionStatus() {
    try {
      const { data: session } = await supabase.auth.getSession();
      const user = session?.user;
      
      if (!user) return null;

      const { data: userProfile } = await supabase
        .from('users')
        .select(`
          org_id,
          orgs!inner(
            id,
            name,
            plan_code,
            billing_status,
            stripe_customer_id,
            stripe_subscription_id
          )
        `)
        .eq('id', user.id)
        .single();

      return userProfile?.orgs || null;
    } catch (error) {
      console.error('Subscription status fetch failed:', error);
      return null;
    }
  },

  async cancelSubscription() {
    try {
      const status = await this.getSubscriptionStatus();
      if (!status?.stripe_subscription_id) {
        throw new Error('No active subscription found');
      }

      // This would typically call a backend endpoint or Stripe API
      // For now, we'll update the database directly
      const { data, error } = await supabase.from('orgs')
        .update({ billing_status: 'canceled' })
        .eq('id', status.id);

      return { success: true };
    } catch (error) {
      console.error('Subscription cancellation failed:', error);
      throw error;
    }
  },

  formatPrice(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }
};